<template>
  <div class="attendance-clock-record-page">
    <PageHeaderLayout>
      <div class="main-page-content">
        <AttendanceTabs
          :tabs="attendanceTabs"
          :active-key="currentTabKey"
          @change="event_tabClick"
        />
        <keep-alive>
          <component :is="currentTabComponent" />
        </keep-alive>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import AttendanceTabs from "./components/AttendanceTabs";
import AttendanceClockRecordList from "./components/AttendanceClockRecordList";
import AttendanceWorkStatsPanel from "./components/AttendanceWorkStatsPanel";
import AttendanceAbnormalPanel from "./components/AttendanceAbnormalPanel";

const PAGE_STATE_KEY = "attendance_clock_record_page_state";

export default {
  name: "AttendanceClockRecord",
  components: {
    PageHeaderLayout,
    AttendanceTabs,
    AttendanceClockRecordList,
    AttendanceWorkStatsPanel,
    AttendanceAbnormalPanel,
  },
  computed: {
    currentTabKey() {
      const currentTab = this.attendanceTabs[this.attendanceTabIndex];
      return currentTab ? currentTab.key : "record";
    },
    currentTabComponent() {
      const componentMap = {
        record: "AttendanceClockRecordList",
        stats: "AttendanceWorkStatsPanel",
        abnormal: "AttendanceAbnormalPanel",
      };
      const currentTab = this.attendanceTabs[this.attendanceTabIndex];
      return componentMap[currentTab.key];
    },
  },
  data() {
    return {
      attendanceTabIndex: 0,
      attendanceTabs: [
        {
          label: "打卡记录",
          key: "record",
        },
        {
          label: "工时统计",
          key: "stats",
        },
        {
          label: "异常考勤",
          key: "abnormal",
        },
      ],
    };
  },
  mounted() {
    this.restorePageState();
  },
  beforeDestroy() {
    this.savePageState();
  },
  methods: {
    savePageState() {
      window.sessionStorage.setItem(
        PAGE_STATE_KEY,
        JSON.stringify({
          attendanceTabIndex: this.attendanceTabIndex,
        }),
      );
    },
    restorePageState() {
      const raw = window.sessionStorage.getItem(PAGE_STATE_KEY);
      if (!raw) return;
      try {
        const state = JSON.parse(raw);
        if (state && typeof state.attendanceTabIndex === "number") {
          this.attendanceTabIndex = state.attendanceTabIndex;
        }
      } catch (e) {
        window.sessionStorage.removeItem(PAGE_STATE_KEY);
      }
    },
    event_tabClick(item) {
      this.attendanceTabIndex = this.attendanceTabs.findIndex((tab) => tab.key === item.key);
      this.savePageState();
    },
  },
};
</script>
